module.exports = __webpack_public_path__ + "img/b14.24a5a26f.png";